window.mainnavigation     = false;
window.mainnavigationLink = false;

function init() {

  const documentHeight                      = document.documentElement.clientHeight;
  const headerElement                       = document.querySelector('.header');
  const headerHeight                        = (headerElement) ? headerElement.offsetHeight : false;
  const mainnavigationElement               = document.querySelector('.mainnavigation');
  const mainnavigationElementInner          = document.querySelector('.mainnavigation__containerinner');
  const mainnavigationElementOpenClassName  = 'mainnavigation--open';
  const mainnavigationBottomMargin          = 80;
  const mainnavigationLink                  = Array.from(document.querySelectorAll('.header__mainnavigationlink'));
  // margin-top and height for inner mainnavi element
  if (documentHeight && headerHeight && mainnavigationElementInner) {
    mainnavigationElementInner.style.marginTop = headerHeight - 2 + 'px'; // substracted border of header
    mainnavigationElementInner.style.height    = documentHeight - headerHeight - mainnavigationBottomMargin + 'px';
  }

  // add event listener to mainnavi link
  if (!window.mainnavigation && mainnavigationLink && mainnavigationElement && mainnavigationElementInner) {
    window.mainnavigation = true;

    mainnavigationLink.map((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        // toggle mainnavigation open
        mainnavigationElement.classList.toggle(mainnavigationElementOpenClassName);
        toggleMainnavigationRelatives(link);

        window.mainnavigationLink = link;
      });
    });

    // close mainnavigation when clicked outisde
    let mainnavigationOutsideClick = function(e) {
      let isClickInside = mainnavigationElementInner.contains(e.target) || window.mainnavigationLink.contains(e.target);
      if (!isClickInside) {
        if (mainnavigationElement.classList.contains(mainnavigationElementOpenClassName)) {
          toggleMainnavigationRelatives();
        }
        mainnavigationElement.classList.remove(mainnavigationElementOpenClassName);
      }
    }

    function toggleMainnavigationRelatives(link = false) {
      // toggle (all) mainnavilink icon close
      let mainnavigationLinkIcon = Array.from(document.querySelectorAll('.header__mainnavigationlink .icon'));

      if (mainnavigationLinkIcon) {
        mainnavigationLinkIcon.map((icon) => {
          icon.classList.toggle('icon-burger');
          icon.classList.toggle('icon-burger_close');
        })
      }
      // toggle style elements on header
      if (headerElement) {
        headerElement.classList.toggle('header--mainnavigation--open');
      }
      // add/remove outside click handler
      if (mainnavigationElement.classList.contains(mainnavigationElementOpenClassName)) {
        document.addEventListener('click', mainnavigationOutsideClick);
      } else {
        document.removeEventListener('click', mainnavigationOutsideClick);
      }
    }
  }
}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Mainnavigation.js